// DO NOT EDIT
  // this file is generated by /internals/populate-icons script
  import * as React from 'react'
  // @ts-ignore
  import { Edit } from 'react-feather'
  import IconBase from './../../IconBase'

  function IconEdit(props: any) {
    return <IconBase icon={Edit} {...props} />
  }

  export default IconEdit
  